import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'
import { gql, useMutation } from '@apollo/client'
import clsx from 'clsx'

const SEND_PASSWORD_RESET_EMAIL = gql`
  mutation SendPasswordResetEmail($username: String!) {
    sendPasswordResetEmail(input: { username: $username }) {
      user {
        email
      }
    }
  }
`
const Forgot = () => {
  const [sendPasswordResetEmail] = useMutation(SEND_PASSWORD_RESET_EMAIL)
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    criteriaMode: 'all',
  })
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [formMessage, setFormMessage] = useState('')

  const onFormSubmit = async ({ email }) => {
    try {
      setLoading(true)

      await sendPasswordResetEmail({
        variables: {
          username: email,
        },
      })

      // Show the success message
      setFormMessage('An email has been sent.')
      setSuccess(true)
    } catch (err) {
      console.error('sendResetEmail :: err ::', JSON.stringify(err))
      setFormMessage('Unable to request a password reset. Please try again!')
      setSuccess(false)
    } finally {
      setLoading(false)
    }
  }

  return (
    <main className="min-h-[calc(100vh-200px)]">
      <div className="container pb-20 pt-2">
        <h1 className="mb-10 text-center text-4xl font-bold text-skin-accent">
          recover password.
        </h1>
        <div className="mx-auto flex w-[315px] flex-col items-center divide-y divide-light-gray rounded-[19px] bg-white py-2 pb-10 shadow-lg [&>*]:px-6">
          {/** Header */}
          {!success && (
            <div className="py-4 text-sm font-bold text-flame">
              Enter your email address below
            </div>
          )}

          <div className="w-full">
            {/** Form message  */}
            <div
              className={clsx(
                'font-bold opacity-0 transition-opacity',
                formMessage !== '' && 'mt-5 opacity-100',
                !success && 'text-red-500'
              )}
            >
              {formMessage}
            </div>
            {success ? (
              <p className="mt-3 text-left">
                Please check your email for instruction on how to reset your
                password.
              </p>
            ) : (
              <div className="text-center">
                <form
                  className={clsx('group mt-6', loading && 'loading')}
                  onSubmit={handleSubmit(onFormSubmit)}
                >
                  {/** Email input */}
                  <fieldset className="mb-5">
                    <input
                      {...register('email', { required: true })}
                      name="email"
                      type="email"
                      placeholder="Email"
                      className={clsx(
                        'w-full rounded-[6.5px] placeholder-dark-gray',
                        errors.email ? 'border-red-500' : 'border-light-gray'
                      )}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="email"
                      render={() => {
                        return (
                          <p className="text-left text-xs text-red-500">
                            This is required
                          </p>
                        )
                      }}
                    />
                  </fieldset>

                  {/** Recover button */}
                  <input
                    type="submit"
                    value={
                      loading
                        ? 'sending you an email...'
                        : 'email me a recovery link'
                    }
                    disabled={loading}
                    className="w-full cursor-pointer rounded-full bg-skin-button-accent px-6 pt-[0.6rem] pb-3 font-bold text-white transition-colors group-[.loading]:cursor-not-allowed group-[.loading]:opacity-50 group-[:not(.loading)]:hover:bg-skin-button-accent-hover group-[:not(.loading)]:active:translate-y-[0.75px] group-[:not(.loading)]:active:scale-[0.99]"
                  />
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  )
}

export default Forgot
